module.exports = __webpack_public_path__ + "static/media/mstile-310x310.e5deb248.png";